var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.25C3.77688 0.25 2.375 1.65188 2.375 3.375V5.25H1.75C1.06062 5.25 0.5 5.81063 0.5 6.5V11.5C0.5 12.1894 1.06062 12.75 1.75 12.75H9.25C9.93937 12.75 10.5 12.1894 10.5 11.5V6.5C10.5 5.81063 9.93937 5.25 9.25 5.25H8.625V3.375C8.625 1.65188 7.22312 0.25 5.5 0.25ZM9.25 6.5L9.25125 11.5H1.75V6.5H9.25ZM3.625 5.25V3.375C3.625 2.34125 4.46625 1.5 5.5 1.5C6.53375 1.5 7.375 2.34125 7.375 3.375V5.25H3.625Z",
    fill: "#7A7C7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.eb8af5841d1ecfbc8a55c137f056a508.svg";
export { ForwardRef as ReactComponent };